// React and related imports
import React from 'react';

// Flowbite components
import { Table } from 'flowbite-react';

// Custom components
import { TableCell } from '../../components/Table/Table';
import { EditButton } from '../../components/Shared/EditButton';

// Utilities
import { getCorrectAnswerForQuestion } from '../../utils/getCorrectAnswer';
import { getLocalizedValueFromMultiLangValues } from '../../utils/getLocalizedValueFromMultiLangValues';

// Interfaces
import { IQuestion } from '../../common/interfaces/Question.interface';

// i18 translations
import { useTranslation } from 'react-i18next';

interface QuestionsTableBodyProps {
  questionsList: IQuestion[];
  handleEditQuestion: (question: IQuestion) => void;
}

export const QuestionsTableBody: React.FC<QuestionsTableBodyProps> = ({
  questionsList,
  handleEditQuestion,
}) => {
  const { t } = useTranslation();

  return (
    <Table.Body>
      {questionsList.map((question) => (
        <Table.Row key={question.id}>
          <TableCell>
            {getLocalizedValueFromMultiLangValues(question.body)}
          </TableCell>
          <TableCell>{t(`status.${question.status}`)}</TableCell>
          <TableCell>
            {/* TODO : remove optional chaining operator after fixing the API response */}
            {question.answers?.[0]?.dataSources?.[0].options.length ||
              t('questions.noOptions')}
          </TableCell>
          <TableCell>
            {getCorrectAnswerForQuestion(question) ||
              t('questions.noCorrectAnswer')}
          </TableCell>
          <TableCell>
            <EditButton onClick={() => handleEditQuestion(question)} />
          </TableCell>
        </Table.Row>
      ))}
    </Table.Body>
  );
};
